/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

export type TasksTemplatesExtendedListFreightMethod = typeof TasksTemplatesExtendedListFreightMethod[keyof typeof TasksTemplatesExtendedListFreightMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TasksTemplatesExtendedListFreightMethod = {
  AIR: 'AIR',
  OCEAN: 'OCEAN',
} as const;
